export enum OperationValidationStatus {
  WAITING = "WAITING",
  REFUSED = "REFUSED",
  VALIDATED = "VALIDATED",
}
